import axios from 'axios';
import {apiService} from "../../services/api.service";
import {convertToPageable, downloadFileWithPresignedUrl, handleResponse} from "../../helpers/apiResponseHelper";

async function findChargingReports(pageRequest: any) {
    return axios.get(`${apiService.getApiUrl()}/charging/reports/admin`, {
        params: pageRequest
    }).then(handleResponse).then(convertToPageable);
}

async function getChargingReportFile(chargingReportId: number) {
    return axios.get(apiService.getApiUrl() + `/charging/reports/admin/${chargingReportId}/file`)
      .then(handleResponse).then((res) => downloadFileWithPresignedUrl(res.data));
  }

export const ChargingReportsService = {
    findChargingReports,
    getChargingReportFile
};